import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportEstimationToPdf = (estimationData) => {
  const doc = new jsPDF();
  const title = "Good Faith Estimation";

  // Set larger font size for the title
  doc.setFontSize(20); // Increase font size to 20
  const titleWidth = doc.getTextWidth(title);
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight(); // Get page height
  const marginTop = 10; // Top margin
  const marginBottom = 10; // Bottom margin
  let currentY = marginTop + 15; // Start below the title

  // Add the title
  doc.text(title, (pageWidth - titleWidth) / 2, 13); // Center the title

  estimationData.forEach((estimation, index) => {
    // Template Title
    doc.setFontSize(14);
    doc.setTextColor(40);
    doc.text(`Care Plan Name: ${estimation.name}`, 14, currentY);
    currentY += 6;

    // Table Headers and Rows
    const treatmentTableBody = estimation.packages.map((pkg) => [
      pkg.name,
      pkg.visit,
      `$${pkg.cost}`,
      `$${pkg.totalCost.toFixed(2)}`,
    ]);

    const totalCost = estimation.packages.reduce(
      (acc, pkg) => acc + pkg.totalCost,
      0
    );

    // Push total as the last row with bold styling
    treatmentTableBody.push([
      {
        content: "Total Plan Cost",
        colSpan: 3,
        styles: { fontStyle: "bold", halign: "right" },
      },
      {
        content: `$${totalCost.toFixed(2)}`,
        styles: { fontStyle: "bold" },
      },
    ]);

    autoTable(doc, {
      startY: currentY,
      head: [["Treatments", "Visits", "Cost Per Visit($)", "Total"]],
      body: treatmentTableBody,
      styles: {
        fontSize: 10,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        fontStyle: "bold",
      },
      margin: { left: 14, right: 14 },
      didDrawPage: (data) => {
        currentY = data.cursor.y + 10; // Update currentY after drawing the table
      },
    });

    doc.setFontSize(14);
    doc.setTextColor(40);
    doc.text(`Payment Option`, 14, currentY);
    currentY += 3;

    const paymentTableBody = estimation.payments.map((pkg) => [
      pkg.payments,
      pkg.discount,
      pkg.upfront,
      `$${(
        (totalCost * (1 - pkg.discount / 100).toFixed(2) - pkg.upfront) /
        pkg.payments
      ).toFixed(2)}`,
      `$${totalCost * (1 - pkg.discount / 100).toFixed(2)}`,
    ]);

    autoTable(doc, {
      startY: currentY,
      head: [
        [
          "Number of Payments",
          "Discount",
          "Upfront Payment",
          "Monthly",
          "Total",
        ],
      ],
      body: paymentTableBody,
      styles: {
        fontSize: 10,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        fontStyle: "bold",
      },
      margin: { left: 14, right: 14 },
      didDrawPage: (data) => {
        currentY = data.cursor.y + 10; // Update currentY after drawing the table
      },
    });

    // Check if the next content will overflow the page
    if (currentY + 20 > pageHeight - marginBottom) {
      doc.addPage(); // Add a new page
      currentY = marginTop; // Reset Y position for the new page with marginTop
    } else {
      currentY += 20; // Add spacing before the next content
    }
  });

  // doc.save("EstimationData.pdf");
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};
